module.exports = __webpack_public_path__ + "img/10.d47e0780.jpg";